exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".forum-container{font-size:1.5rem;color:#000;margin-top:20px}.forum-container .text-muted{color:#767676}.forum-container .list-group-item.forum h4{text-transform:capitalize}.forum-container .container-fluid.forum .list-group-item h4{font-size:1.6rem}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/css/forum.less
 ** module id = 776
 ** module chunks = 0
 **/